import { sharePointHelpers } from '@qdabra/forms-shared/sharePoint';
import { getParameterByName as param } from '@qdabra/forms-shared/urlHelpers';
import { curry } from 'ramda';
import {
    DEFAULT_LCID,
    TERMSET_QUERY_IDS,
    TERMSET_QUERY_LABEL,
} from './sharePoint.constants';
import { buildTermSetsDoc } from './sharePoint.termSets.xml.builder';

const isBrowser = typeof window !== 'undefined';

const hostWebUrl = isBrowser && param('SPHostUrl');
const appWebUrl = isBrowser && param('SPAppWebUrl');

const { ensureSharePointFilename, getDomainFromUrl } = sharePointHelpers;

const QUERY_MODE_SERVER = 'server';
const QUERY_MODE_CLIENT = 'client';

// () -> Boolean
export const shouldUseClient = (sharePointSettings) => {
    // 53319 - useClient is now determined by server and indicated in sharePointSettings
    const queryMode = sharePointSettings.queryMode;

    switch (queryMode) {
        case QUERY_MODE_SERVER:
            return false;
        case QUERY_MODE_CLIENT:
            return true;
        default:
            throw new Error('Unexpected queryMode value: ' + queryMode);
    }
};

const urlsHaveSameDomain = curry((url1, url2) => {
    var d1 = getDomainFromUrl(url1);
    var d2 = getDomainFromUrl(url2);

    var areSame = d1 && d2 && d1.toLowerCase() === d2.toLowerCase();

    return !!areSame;
});

const isInHostWebDomain = urlsHaveSameDomain(hostWebUrl);

const getTermSetsByIds = async (shpAccess, siteUrl, lcid, ids) => {
    const termSets = await shpAccess.getTermSetsAsync(
        TERMSET_QUERY_IDS,
        siteUrl,
        lcid || DEFAULT_LCID,
        { ids },
    );

    return buildTermSetsDoc(termSets);
};

const getTermSetsByLabel = async (
    shpAccess,
    siteUrl,
    lcid,
    searchText,
    matchOption,
) => {
    const termSets = await shpAccess.getTermSetsAsync(
        TERMSET_QUERY_LABEL,
        siteUrl,
        lcid || DEFAULT_LCID,
        { searchText, matchOption },
    );

    return buildTermSetsDoc(termSets);
};

export {
    // String
    appWebUrl,
    // String -> String
    ensureSharePointFilename,
    getTermSetsByIds,
    getTermSetsByLabel,
    // String
    hostWebUrl,
    // String -> Boolean
    isInHostWebDomain
};

